import React, { FC, HTMLAttributes } from 'react';
import { NavLink } from 'react-router-dom';

import classNames from '../../helpers/classNames';
import useTranslate from '../../hooks/useTranslate';
import { inspirationCategories } from '../../services/apis/inspirations/consts';
import { InspirationType } from '../../services/apis/inspirations/types';
import styles from './InspirationNavBar.module.scss';

interface InspirationNavBarProps extends HTMLAttributes<HTMLUListElement> {
  activeCategory?: InspirationType['category'];
}

const InspirationNavBar: FC<InspirationNavBarProps> = props => {
  const { activeCategory, className, ...rest } = props;
  const { translate } = useTranslate();
  const activeIndex = inspirationCategories.findIndex(category => activeCategory === category);

  return (
    <ul className={classNames(styles.list, className)} {...rest}>
      <li>
        <NavLink
          to=""
          className={classNames(styles.item, activeIndex === -1 ? styles.active : null)}
        >
          {String(translate(`Inspirations.categories.all`))}
        </NavLink>
      </li>
      {inspirationCategories.map((category, index) => {
        const isActive = activeIndex === index;

        return (
          <li key={category}>
            <NavLink
              to={isActive ? '' : `?category=${category}`}
              className={classNames(styles.item, isActive ? styles.active : null)}
            >
              {String(translate(`Inspirations.categories.${category}`))}
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
};

export default InspirationNavBar;
